export default __webpack_public_path__ + "static/zflow-link-inss-img-f6dfcaea6b81368f27a82c5458e7fca2.png";